import {useContext, useEffect} from 'react';
import {FieldContext} from './field-wrapper';
import type {IWrapperProvider, JSONValue, allSchemas} from './types';

export function useFieldSetup(
  tag: string,
  initial: JSONValue | Record<string, JSONValue>,
  schema?: allSchemas,
) {
  const {registerField, state} = useContext<IWrapperProvider>(
    FieldContext as any,
  );

  useEffect(() => {
    registerField(tag, schema, false, state[tag] || initial);
    return () => {
      registerField(tag, schema, true, undefined);
    };
  }, [schema]);

  return;
}
